/**
 * MMOHUDMobileScene — Dedicated mobile HUD.
 *
 * Extends the main MMOHUDScene but:
 *   - Registers under a distinct scene key ('MMOHUDMobileScene') so the login
 *     flow can route mobile users without touching the desktop scene.
 *   - Forces `mobile = true` regardless of viewport auto-detect (so Chrome
 *     DevTools mobile emulation and `?mobile=1` URL overrides always win).
 *   - Skips the Phaser-drawn top bar entirely. The DOM overlay supplies its
 *     own touch-friendly top bar (Stations / Ships / Credits / BUY SHIP) so
 *     the Phaser one would only duplicate it and waste vertical space.
 *
 * Everything else — managers, event wiring, Phase 3 dialogs, Command Dock,
 * Mode banner, Mobile DOM overlay, chat panel — is reused from the parent
 * class. This keeps the two scenes in lock-step feature-wise while letting
 * the mobile scene diverge safely for platform-specific concerns.
 */

import { MMOHUDScene } from './MMOHUDScene';

export class MMOHUDMobileScene extends MMOHUDScene {
  constructor() {
    super('MMOHUDMobileScene');
  }

  init(): void {
    super.init();
    // Force mobile branch in parent.create(). This is idempotent — the parent
    // also ORs with isMobile(this) so the flag stacks cleanly.
    this.forceMobileLayout = true;
    this.skipPhaserTopBar = true;
  }
}
